import React, { Suspense } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import OrderHistorySectionCard from "@/features/my-order/features/order-history/components/OrderHistorySectionCard";
import OrderHistoryInquiryContent from "@/features/my-order/features/order-history/components/inquiry-section/OrderHistoryInquiryContent";
import InquiryUnreadBadge from "@/features/my-order/features/order-history/components/inquiry-section/InquiryUnreadBadge";
import CenteredSpinner from "@/shared/components/centered-spinner";

// 페이지 트리에 그대로 마운트되는 일반 섹션 카드.
// (이전에 채널톡 스타일 플로팅 위젯이었으나 우측 패널 배치로 되돌림)
function OrderHistoryInquirySection() {
  // 페이지마다 식별자 전달 방식이 다르다:
  //  - /order-sheets/:orderSheetSetId    → 라우트 path param
  //  - /…/order-history?order_sheet_set_id=… → 쿼리 파라미터
  const params = useParams();
  const [searchParams] = useSearchParams();
  const orderSheetSetId =
    params.orderSheetSetId ?? searchParams.get("order_sheet_set_id");
  const numericOrderSheetSetId = orderSheetSetId ? +orderSheetSetId : null;

  return (
    <OrderHistorySectionCard
      titleKey={"order_history:inquiry.section_title"}
      iconSrc={"cs"}
      badge={<InquiryUnreadBadge orderSheetSetId={numericOrderSheetSetId} />}
    >
      <Suspense fallback={<CenteredSpinner />}>
        <OrderHistoryInquiryContent orderSheetSetId={numericOrderSheetSetId} />
      </Suspense>
    </OrderHistorySectionCard>
  );
}

export default OrderHistoryInquirySection;
